<template>
    <div
        class="w-[95%] max-w-4xl m-4 sm:ml-2 md:ml-8 xl:ml-16 relative flex flex-col items-center justify-center bg-white rounded-xl shadow-md">
        <div class="p-8">
            <h1 class="text-xl font-semibold text-gray-700">Personal details</h1>
            <p class="text-sm text-gray-500">
                Choose how you’d like to be identified by others who have access to projects you work with. If no name
                is provided, Folia will default to your email address. The email address associated with your account is
                listed here (cannot be changed).
            </p>
            <div class="">
                <div class="mt-4 space-4 flex flex-col md:flex-row">
                    <div class="flex-1  m-2">
                        <label for="name" class="block text-sm font-medium text-gray-500">Name</label>
                        <input v-model="name" type="text" id="name"
                            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm text-gray-700"
                            placeholder="Enter your name" />
                    </div>
                    <div class="flex-1 m-2">
                        <label for="email" class="block text-sm font-medium text-gray-500">Email</label>
                        <input v-model="email" type="email" id="email"
                            class="mt-1 block w-full bg-gray-200 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm text-gray-700"
                            disabled />
                    </div>

                </div>
                <div class="flex justify-end relative w-full h-full">
                    <button @click="saveDetails" type="button" class="mt-4 w-full md:w-32 cursor-pointer rounded-md border border-transparent bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 
                        float-right" :disabled="isActionInProgress">
                        Save
                    </button>


                </div>
            </div>
        </div>
        <div v-if="isActionInProgress"
            class="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 backdrop-blur-sm rounded-lg shadow-sm flex items-center justify-center">
            <DefaultLoader />
        </div>
        <div v-if="showSelfDelete" class="w-full p-8">
            <hr class="w-full border-t border-gray-200" />
            <div class="flex flex-row w-full p-8">
                <div class="flex flex-col w-full">

                    <h1 class="text-xl font-semibold text-gray-700">Delete Account</h1>
                    <p class="text-sm text-gray-500">
                        Delete your account and the data associated with it.
                    </p>
                </div>
                <div class="flex justify-end relative w-full h-full">
                    <button @click="deleteAccount" type="button" class="mt-4 w-full md:w-48  cursor-pointer rounded-md border border-transparent bg-red-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-red-400 
                                float-right">
                        Delete Account
                    </button>
                </div>
            </div>
        </div>
        <hr class="w-[90%] border-t border-gray-200" />

        <div class="flex flex-row w-full p-8">
            <div class="flex justify-center relative w-full h-full">
                <button @click="clearIndexDb" type="button" class="mt-4 w-full md:w-48  cursor-pointer rounded-md border border-transparent bg-orange-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-orange-400 
                        ">
                    Clear profile cache
                </button>
            </div>
        </div>
    </div>
    <DeleteAccountConfirmation v-if="showDeleteModal" :userEmail="email" @close="showDeleteModal = false"
        @deleted="handleAccountDeleted" />
    <AccountDeletionConfirmedScreen v-if="showDeletedScreen" />
</template>

<script>
import { onMounted, ref,computed } from 'vue';
import ProfileService from '../../../../service/profileService';
import DefaultLoader from '../../loaders/defaultLoader.vue';
import DeleteAccountConfirmation from './DeleteAccountConfirmation.vue';
import AccountDeletionConfirmedScreen from './AccountDeletionConfirmedScreen.vue';
import { useRouter } from "vue-router";

export default {
    name: "ProfileSettings",
    components: {
        DefaultLoader,
        DeleteAccountConfirmation,
        AccountDeletionConfirmedScreen
    },
    setup() {
        const router = useRouter();
        const name = ref('');
        const email = ref('');
        const initialName = ref('');
        const profileService = new ProfileService();
        const isActionInProgress = ref(false);
        const isB2BUser = ref(false);
        const showSelfDelete = computed(() => {
            return isB2BUser.value;
        });
        onMounted(async () => {
            isActionInProgress.value = true;
            const { name: n = null, email: e = '', profilePicture = '',isB2BUser: b2b = false } = await profileService.getMyProfile();            
            isB2BUser.value = !b2b;
            name.value = n;
            email.value = e;
            initialName.value = n;
            isActionInProgress.value = false;
        });
        const showDeleteModal = ref(false);
        const showDeletedScreen = ref(false);
        const handleAccountDeleted = () => {
            // show the full-screen deletion confirmation which will handle logout/redirect
            showDeletedScreen.value = true;
        };
        const saveDetails = async () => {
            try {
                if (name.value !== initialName.value) {
                    isActionInProgress.value = true;
                    await profileService.updateUserProfile({ email: email.value, name: name.value });
                }

            } catch (error) {
                console.log(error);

            } finally {
                isActionInProgress.value = false;
            }

        };
        const deleteAccount = () => {
            showDeleteModal.value = true;
        };

        const clearIndexDb = () => {
            indexedDB.deleteDatabase('FOLIA_CACHE');
            router.push({ name: 'home' }).then(() => {
                location.reload();
            });
        }
        return {
            name, email,
            saveDetails,
            isActionInProgress,
            clearIndexDb,
            deleteAccount,
            showDeleteModal,
            showDeletedScreen,
            handleAccountDeleted,
            showSelfDelete
        };
    },
};
</script>

<style scoped></style>